/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".invoice-not-found[_ngcontent-%COMP%]{width:300px!important}.invoice-not-found__error-header[_ngcontent-%COMP%]{font-family:Roboto-Medium,Roboto Medium,Roboto,sans-serif;font-size:18px;font-weight:500;padding-bottom:32px}.invoice-not-found__error-message[_ngcontent-%COMP%]{font-family:Roboto-Regular,Roboto Regular,Roboto,sans-serif;font-size:12px;font-weight:400}"];
export { styles as styles };

